export class Step6 {

    public getnboffresrecues = 'form.mapa_at.getnboffresrecues';
    public getinformations = 'form.mapa_at.getinformations';
    public getspan14 = 'form.mapa_at.getspan14';
    public getspan15 = 'form.mapa_at.getspan15';
    public getnbparticipants = 'form.mapa_at.getnbparticipants';
    public getnbparticipantsetrangers = 'form.mapa_at.getnbparticipantsetrangers';
    public getspan16 = 'form.mapa_at.getspan16';
    public getvaleurprime = 'form.mapa_at.getvaleurprime';
    public getdevise = 'form.mapa_at.getdevise';
}
